import { useGetProviderIconUrl } from '../hooks/use-get-provider-icon-url'
import type { BaseIconProps } from './base-provider-icon'
import { BaseProviderIcon } from './base-provider-icon'

export const ATTFleetManagementIcon = ({ size }: BaseIconProps) => {
  const iconUrl = useGetProviderIconUrl('att-fleet-management-logo', 'logo')

  return <BaseProviderIcon size={size} src={iconUrl} label="att-fleet-management-icon" />
}
